import Toasts from './Toasts.vue';
import bus from '/src/utils/bus.js';

function toast (toast) {
	bus.emit('toasts:add', toast);
}

function clearToast (toast) {
	bus.emit('toasts:clear', toast);
}

export {
	Toasts,
	toast,
	clearToast,
};
